import { h, Component } from 'preact';
import { accessNested, debounce, joinClasses, sortObjectByOrder } from 'utils/utils';
import HTML from 'components/core/html/html';
import Tile from 'components/bolt/tiledItems/tile/tile';
import Store from 'store/store';
import 'store/bolt/tiledItems';
import s from 'components/bolt/tiledItems/tiledItems.sss';
import { getSizeOverride } from 'utils/bolt/index';
import { navigateInternally } from 'utils/bolt';



export default class TiledItems extends Component {
	constructor(props) {
		super(props);

		this.state = {
			tilesArray: []
		};

		this.$tileRefs = {};
		this.onResize = debounce(this.onResize.bind(this));
	}

	componentDidMount() {
		window.addEventListener('resize', this.onResize);
		this.getTilesArray();
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.onResize);
		Store.emit('ADD_TILED_ITEMS_FOOTER_SHADOW', false);
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.id !== prevProps.id) {
			this.getTilesArray();
		}
		if (prevState.tilesArray !== this.state.tilesArray) {
			this.getShortestTile();
		}
	}

	onClick(e) {
		let internalLink = e.target.closest('a[href^="#$"]');
		if (internalLink) {
			e.preventDefault();
			let page = internalLink.getAttribute('href').slice(2).trim();
			let navOptions = {};
			if (page.includes('/?')) {
				let [pageId, qs] = page.split('/?');
				page = pageId;
				navOptions.queryString = '?' + qs;
			}
			navigateInternally(page, navOptions);
		}
	}

	onResize() {
		this.getShortestTile();
	}

	getShortestTile() {
		const height = Object.values(this.$tileRefs).filter(e => e).map(e => e.getNaturalContentHeight()).sort((a, b) => a - b)[0];
		this.setState({ shortestTile: Math.max(height, 450) });
	}

	getTilesArray() {
		const isDesktopSize = this.props.client?.deviceSize === 'desktop' || this.props.client?.deviceSize === 'largeDesktop';
		let tilesArray = Object.values(accessNested(this.props, `appData.pages.${this.props.id}.data.tiles`, {}));
		if (!tilesArray.length) return;
		
		tilesArray = sortObjectByOrder(tilesArray);
		
		if (tilesArray.length === 1) {
			const tileData = sortObjectByOrder(tilesArray[0].tilesData);
			const numberOfRows = tileData.length;
			const hasMultipleRows = numberOfRows > 2;

			if (hasMultipleRows) {
				let newTilesArray = [];
				for (let i = (Math.round(numberOfRows / 2)); i > 0; i--) {
					newTilesArray.push({
						tilesData: tileData.splice(0, Math.ceil(tileData.length / i)),
						orientation: tilesArray[0].orientation
					});
				}

				tilesArray = newTilesArray;
			} else {
				tilesArray = [{
					tilesData: tileData,
					orientation: tilesArray[0].orientation
				}];
			}
		}

		this.setState({ tilesArray });

		const isSection = this.props.appData.pages[this.props.id]?.section;
		const needsFooterShadow = isDesktopSize ? tilesArray.length % 2 === 0 : tilesArray[tilesArray.length - 1].tilesData.length % 2 === 0;

		if (!isSection) {
			Store.emit('ADD_TILED_ITEMS_FOOTER_SHADOW', needsFooterShadow);
		}
	}

	renderTiles() {
		const isDesktopSize = this.props.client?.deviceSize === 'desktop' || this.props.client?.deviceSize === 'largeDesktop';
		const { tilesArray, shortestTile } = this.state;

		const appData = this.props.appData;
		let fixedHeight = getSizeOverride(appData?.pages?.[this.props.id]?.data?.customTileSize);
		const height = fixedHeight || (shortestTile != undefined ? `${shortestTile}px` : '');

		const rows = isDesktopSize ? tilesArray : tilesArray.flatMap(row => row.tilesData.map(tile => ({ ...row, tilesData: [tile] })));

		return rows.map((items, index) => {
			const { tilesData, orientation } = items;
			const isPortrait = orientation === 'portrait';
			if (!tilesData) return;
			const rowData = sortObjectByOrder(tilesData).map((tile, i) => {
				return	(
					<Tile
						ref={e => this.$tileRefs[`tile${i}-${index}`] = e}
						data={tile}
						isPortrait={isPortrait}
						isEvenRow={index % 2 === 0}
						height={height}
					/>
				);
			});

			return (
				<div class={s.row}>
					<div class={joinClasses(s.tiles, isPortrait && s.portraitTiles)}>
						{rowData}
					</div>
				</div>
			);
		}).filter(item => item);
	}

	render(props) {
		const pageTitle = accessNested(props, `appData.pages.${props.id}.data.title`);
		const pageSubtitle = accessNested(props, `appData.pages.${props.id}.data.description`);
		const isSection = accessNested(props, `appData.pages.${props.id}.section`, false);

		return (
			<div class={joinClasses(s.wrapper, isSection && s.section)} data-section={props.id}>
				<HTML tag="div" markdown onClickCapture={this.onClick} markdown content={pageTitle} class={joinClasses(s.pageTitle, 'xlargeB')} content={pageTitle} />
				{pageSubtitle && <HTML tag="h2" markdown content={pageSubtitle} class={joinClasses(s.pageSubtitle)} />}
				<div class={s.tileWrapper}>
					{this.renderTiles()}
				</div>
			</div>
		);
	}
}
